import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { PrivacyPolicy } from "../../entity";

export class GetOnePrivacyPolicyDTO {
  @Expose()
  @ValidateNested()
  @Type(() => PrivacyPolicy)
  privacyPolicy!: PrivacyPolicy;
}
